import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Divider, Grid } from '@mui/material';

const theme = createTheme();

function Footer() {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ThemeProvider theme={theme}>
                <Divider />
                <Container maxWidth="lg">
                    <Typography variant="h6" align="center" gutterBottom>
                        Sean Crim
                    </Typography>
                    <Typography sx={{paddingBottom: '5px'}} variant="body2" color="text.secondary" align="center">
                        {new Date().getFullYear()}
                    </Typography>
                </Container>
            </ThemeProvider>
        </Grid>
    )
}

export default Footer;